import { useEffect } from 'react';
export var useOnMount = function (onMount) { return useEffect(onMount, []); };
